import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable' // curly braces বাদ দিন

// Create a Vue.js plugin to make these libraries available globally
const pdfPlugin = {
  install(app) {
    app.config.globalProperties.$jsPDF = jsPDF;

    app.config.globalProperties.$exportTableToPDF = function(columns, rows, title, filename, orientation = 'portrait', options = {}) {
      const doc = new jsPDF({
        documentProperties: {
          title: title,
        },
        orientation: orientation, // 'portrait' or 'landscape'
        unit: 'mm',
        format: 'a4',
      });

      const text = title;
      const textWidth = doc.getTextDimensions(text).w;
      const pageWidth = doc.internal.pageSize.getWidth();
      const centerX = (pageWidth - textWidth) / 2;
      doc.text(text, centerX, 20);

      let pageNumber = 1;

      // Merge default options with user-provided options
      const tableOptions = {
        head: [columns],
        body: rows,
        margin: { top: 20 },
        startY: 30,
        didDrawPage: function(data) {
          const pageWidth = doc.internal.pageSize.getWidth();
          doc.setFontSize(10);
          doc.text(
            `Page ${pageNumber}`,
            pageWidth - 20,
            doc.internal.pageSize.getHeight() - 10
          );
          pageNumber++;
        },
        ...options
      };

      // Use autoTable as a function, not as a method of doc
      autoTable(doc, tableOptions);

      doc.save(filename + '.pdf');
    };
  },
};

export default pdfPlugin;